import { AxiosError, AxiosResponse } from 'axios';

const notImplementedEndpoint = async (message: string): Promise<never> => {
  const error = new AxiosError(message);
  error.response = {
    data: {
      errors: [{ code: 'not_implemented', detail: message }],
    },
  } as AxiosResponse;
  throw error;
};

export default notImplementedEndpoint;
